import * as React from 'react'
import ThumbImage from './thumb_image'
import ThumbVideo from './thumb_video'
import FileCollaborationToolApp from '../../../../../components/projects/file_collaboration_tool_app'

export default ({ file, downloadAllowed, modelData, isImage, isVideo, adobePreviewFileOptions }) => {
  if (file._clientUploading || file._serverUploading) {
    return (
      <div className="loading" />
    )
  }

  if (isImage) { return <ThumbImage file={file} modeData={modelData} /> }
  if (isVideo) { return <ThumbVideo file={file} modeData={modelData} /> }

  const href = file.downloadUrl || file.href || file.src

  if (downloadAllowed && href) {
    return (
      <a className="download-lnk" href={href} target="_blank">
        <span className="far fa-file-lines" />
      </a>
    )
  }

  if (!downloadAllowed && adobePreviewFileOptions && file) {
    const props = {adobePreviewFileOptions, file, thumb: true}
    return (
      <FileCollaborationToolApp {...props} />
    )
  }

  return (
    <span className="far fa-file-lines" />
  )
}
